<template>
  <div class="login-view">
    <div class="md-layout md-alignment-top">
      <div class="left-side md-layout-item md-medium-size-50 md-small-size-100">
        <md-content>
          <div class="content-container">
            <h1>Welcome to Forms</h1>
            <p>
              Experience a refreshingly easy way to manage a backend for your forms accross the web.
            </p>
            <signup-form ></signup-form>
          </div>
        </md-content>
      </div>
      <div class="right-side md-layout-item md-medium-size-50 md-small-hide">
        <img src="/static/login-picture-01.jpg" alt="A Team Working Together." rel="preload">
      </div>
    </div>
  </div>
</template>

<script>
import SignupForm from '../forms/SignupForm.vue'

export default {
  name: 'SignupView',
  components: {
    SignupForm
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.left-side,
.right-side {
  height: 100vh;
}
.left-side .md-content {
  height: 100%;
  width: 100%;
  background-color: white;
  position: relative;
}
.right-side img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}
.content-container {
  width: 360px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
}
.content-container h1,
.content-container p {
  margin-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Signup.vue